Vue.component('viewerMedals', {
  template: templates.viewerMedals,
  data() {
    return {
      model: {
        medals: []
      }
    }
  },
  mounted() {
    const c = this;
    c.getMedals();

    $('[data-view="viewer-dashboard"]').on('click', '[data-component="viewer-medals"] > .medal', function(e) {
      c.show($(this).clone());
    });

    $('[data-view="viewer-dashboard"]').on('click', '.view-element', function() {
      c.hide();
    });
  },
  methods: {
    getMedals() {
      const c = this;
      //let medals = [];

      medalService.getMedals()
        .then(function (response) {
          //medals = response.data;
          for (let medal of response.data) {
            medal.image = `${root}/images/medals/${medal.id}.png`;
          }
          c.model.medals = response.data;
        })
        .catch(function (error) {
          
        });
    },
    show($element) {
      let id = $element.data('id');
      let video = `/videos/medals/${id}.webm`;

      var testEl = document.createElement( "video" ), webm;
      if ( testEl.canPlayType ) {
          // Check for Webm support
          webm = "" !== testEl.canPlayType( 'video/webm; codecs="vp8, vorbis"' );
          if (webm) {
            $element.find('img').replaceWith(`<video src="${video}" class="video-overlay__video" loop muted autoplay playsinline></video>`);
          }
      }

      //let description = $card.find('.bottom > div:first-of-type').data('description');
      $element.find('.description').attr('class', '');
      $('.view-element > div').append($element);
      $('.view-element').addClass('is-above').addClass('is-visible');
    },
    hide() {
      $('.view-element').removeClass('is-visible');
      setTimeout(function() {
        $('.view-element').removeClass('is-above');
        $('.view-element > div').html('');
      }, 300);
    }
  }
});